(function () {
  if (!window.DeferredMedia) {
    window.DeferredMedia = class DeferredMedia extends HTMLElement {
      constructor() {
        super();
        this.loadButton = this.querySelector('[id^="Deferred-Poster-"]');
        this.loadButton?.addEventListener('click', this.loadContent.bind(this));
      }

      loadContent(focus = true) {
        if (this.getAttribute('loaded')) return;

        const template = this.querySelector('template');
        if (!template) return;

        const content = template.content.firstElementChild.cloneNode(true);
        this.setAttribute('loaded', true);
        this.appendChild(content);
        if (focus) this.querySelector('iframe, video, model-viewer')?.focus?.();
      }
    };
  }

  if (!customElements.get('deferred-media')) {
    customElements.define('deferred-media', window.DeferredMedia);
  }

  if (!customElements.get('modal-opener')) {
    customElements.define(
      'modal-opener',
      class ModalOpener extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button, a, [role="button"]') || this.firstElementChild;
          if (!this.button || this.dataset.rpModalOpenerBound === 'true') return;
          this.dataset.rpModalOpenerBound = 'true';
          this.button.addEventListener('click', (event) => {
            event.preventDefault();
            const modal = document.querySelector(this.dataset.modal);
            modal?.show?.(this.button);
          });
        }
      }
    );
  }

  if (!customElements.get('variant-selects')) {
    customElements.define(
      'variant-selects',
      class VariantSelects extends HTMLElement {
        connectedCallback() {
          if (this.dataset.rpVariantSelectsBound === 'true') return;
          this.dataset.rpVariantSelectsBound = 'true';
          this.addEventListener('change', this.onVariantChange.bind(this));
        }

        onVariantChange(event) {
          const target = event.target;
          const selectedOptionValues = Array.from(
            this.querySelectorAll('select option:checked, fieldset input:checked')
          )
            .map((option) => option.dataset.optionValueId)
            .filter(Boolean);

          publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: { event, target, selectedOptionValues },
          });
        }
      }
    );
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        connectedCallback() {
          if (this.dataset.rpRecommendationsLoaded === 'true') return;
          if (!this.dataset.url || !this.dataset.productId || !this.dataset.sectionId) return;
          this.dataset.rpRecommendationsLoaded = 'true';

          const url = this.dataset.url + '&section_id=' + this.dataset.sectionId + '&product_id=' + this.dataset.productId;
          fetch(url)
            .then((response) => response.text())
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const recommendations = html.querySelector('product-recommendations');
              if (!recommendations || !recommendations.innerHTML.trim()) {
                this.closest('.shopify-section')?.remove?.();
                return;
              }
              this.innerHTML = recommendations.innerHTML;
            })
            .catch(() => undefined);
        }
      }
    );
  }

  if (!customElements.get('slideshow-component')) {
    const BaseSlider = customElements.get('slider-component') || HTMLElement;
    customElements.define(
      'slideshow-component',
      class SlideshowComponent extends BaseSlider {
        connectedCallback() {
          super.connectedCallback?.();
          this.slider = this.querySelector('[id^="Slider-"]');
          this.sliderItemsToShow = Array.from(this.slider?.querySelectorAll('.slider__slide') || []);
          this.currentPage = 1;
          this.autoplayButton = this.querySelector('.slideshow__autoplay');
          this.autoplayButtonIsSetToPlay = false;

          if (this.dataset.rpSlideshowBound === 'true') return;
          this.dataset.rpSlideshowBound = 'true';

          this.slider?.addEventListener('scroll', () => this.updateCurrentPage(), { passive: true });
          this.querySelectorAll('.slider-counter__link').forEach((button, index) => {
            button.addEventListener('click', (event) => {
              event.preventDefault();
              this.sliderItemsToShow[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            });
          });
          this.autoplayButton?.addEventListener('click', () => {
            this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
          });

          if (this.slider?.dataset.autoplay === 'true') this.play();
        }

        updateCurrentPage() {
          if (!this.slider || !this.sliderItemsToShow.length) return;
          const sliderLeft = this.slider.getBoundingClientRect().left;
          let bestIndex = 0;
          let bestDistance = Infinity;
          this.sliderItemsToShow.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - sliderLeft);
            if (distance < bestDistance) {
              bestDistance = distance;
              bestIndex = index;
            }
          });
          this.currentPage = bestIndex + 1;
        }

        pause() {
          window.clearInterval(this.autoplayTimer);
          this.autoplayButtonIsSetToPlay = false;
        }

        play() {
          this.pause();
          this.autoplayButtonIsSetToPlay = true;
          const speed = Number(this.slider?.dataset.speed || this.dataset.speed || 5) * 1000;
          this.autoplayTimer = window.setInterval(() => {
            const nextIndex = this.currentPage >= this.sliderItemsToShow.length ? 0 : this.currentPage;
            this.sliderItemsToShow[nextIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            this.currentPage = nextIndex + 1;
          }, speed || 5000);
        }
      }
    );
  }

  if (!customElements.get('volume-pricing')) {
    customElements.define('volume-pricing', class VolumePricing extends HTMLElement {});
  }

  if (!customElements.get('account-icon')) {
    customElements.define('account-icon', class AccountIcon extends HTMLElement {});
  }

  if (!customElements.get('bulk-modal')) {
    customElements.define(
      'bulk-modal',
      class BulkModal extends HTMLElement {
        connectedCallback() {
          if (this.dataset.rpBulkModalLoaded === 'true' || !this.dataset.url || !this.dataset.sectionId) return;
          this.dataset.rpBulkModalLoaded = 'true';
          fetch(this.dataset.url + '?section_id=' + this.dataset.sectionId)
            .then((response) => response.text())
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const quickOrderList = html.querySelector('quick-order-list');
              if (quickOrderList) this.innerHTML = quickOrderList.outerHTML;
            })
            .catch(() => undefined);
        }
      }
    );
  }
})();
